import styled from 'styled-components'
import { colors, spacing, font } from '@chegg-ui/theme'
import { Link as UiLink } from '@chegg-ui/link'

export const Container = styled.div`
  background-color: ${colors.skyXlight};
  border-top: 2px solid ${colors.greyLight};
  width: 100%;
  margin: 0;
  padding: ${spacing.px12};
  font-weight: ${font.weight.bold};
  text-align: center;
`

export const Link = styled(UiLink)``
